import React from 'react';
import Card from '../Card';
import { shouldShowSubQuestion } from '../Utils/helper';
import { styles } from '../styles';

export default function QuestionsStep({
  gridStyle,
  groupedQuestions,
  isMobile,
  locked,
  onRemoveFile,
  onSetDescriptive,
  onSetUpload,
  onToggleMultiple,
  onToggleUnique,
  qErrors,
  showQuestionError,
  touchQuestion,
}) {
  return (
    <div style={gridStyle}>
      {groupedQuestions.map(({ parent, subQuestions }, idx) => {
        const visibleSubs = subQuestions.filter(sq =>
          shouldShowSubQuestion(parent, sq)
        );

        return (
          <div key={parent.id} style={styles.questionGroup(isMobile)}>
            <Card
              q={parent}
              idx={idx}
              locked={locked}
              errVisible={showQuestionError(parent.id)}
              qErrors={qErrors}
              touchQuestion={touchQuestion}
              onToggleUnique={onToggleUnique}
              onToggleMultiple={onToggleMultiple}
              onSetDescriptive={onSetDescriptive}
              onSetUpload={onSetUpload}
              onRemoveFile={onRemoveFile}
            />

            {!!visibleSubs.length && (
              <div style={styles.subQuestionsGroup}>
                {visibleSubs.map((subQ, subIdx) => (
                  <Card
                    key={subQ.id}
                    q={subQ}
                    idx={`${idx + 1}.${subIdx + 1}`}
                    locked={locked}
                    errVisible={showQuestionError(subQ.id)}
                    qErrors={qErrors}
                    touchQuestion={touchQuestion}
                    onToggleUnique={onToggleUnique}
                    onToggleMultiple={onToggleMultiple}
                    onSetDescriptive={onSetDescriptive}
                    onSetUpload={onSetUpload}
                    onRemoveFile={onRemoveFile}
                  />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
